import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { useOktaAuth } from '@okta/okta-react'

import NavBar from './components/NavBar'
import { fetchedSelector, fetchingSelector } from './selectors/configurationSelectors'
import * as configurationActions from './actions/configurationActions'
import Toaster from './components/Toaster'

const App = ({ children, fetchConfiguration, fetching, fetched }) => {
  const { authState } = useOktaAuth()
  useEffect(() => {
    if (!fetching && !fetched && authState?.isAuthenticated) {
      fetchConfiguration(authState.accessToken.accessToken)
    }
  }, [authState, fetchConfiguration, fetching, fetched])

  return (
    <>
      <aside>
        <Toaster />
      </aside>
      <header>
        <NavBar />
      </header>
      <Container role="main" as="main" className="flex-fill d-flex flex-column">
        {children}
      </Container>
      <footer className="d-flex align-items-center p-2 text-muted">
        &copy; {new Date().getFullYear()} - <img className="ml-1" src="/logo.png" alt="Meredith" height="20" />
      </footer>
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  fetching: fetchingSelector,
  fetched: fetchedSelector,
})

const mapDispatchToProps = {
  fetchConfiguration: configurationActions.fetchConfiguration,
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(App)
